/**
 * This enum is a replica of the UlsCat defined in //depot/devmain/browsertelemetry/Diagnostics/API/Categories.cs
 * Do not add new categories here, only copy the needed categories from the above file
 */
export enum LogCategory {
  msoulscat_ES_EWAJS = 0,
  msoulscat_ES_EWAJSGrid = 1,
  msoulscat_ES_EWAJSChart = 6,
  msoulscat_MSOSP_FileMenuCommands = 202,
  msoulscat_MSOSP_AddInCommands = 220,
  msoulscat_MSOSP_OTelJS = 225,
  // msoulscat_MSOSP_OTelJSBoostrap = 226,
  msoulscat_MSOSP_OTelJSInWebWoker = 227,
  msoulscat_MSOSP_OTelJSWebWorkerPrototype = 228,
  // msoulscat_MSOSP_OTelJSTest = 229,
  msoulscat_Wac_WordViewer = 301,
  msoulscat_Wac_BrowserGeneral = 306,
  msoulscat_Wac_TaskPane = 320,
  msoulscat_Wac_OneNoteGeneral = 339,
  msoulscat_Wac_Ribbon = 340,
  msoulscat_Wac_WacFeedback = 356,
  msoulscat_Wac_WopiPendingApplication = 379,
  msoulscat_Wac_Telemetry = 383,
  msoulscat_Wac_WacCatchUpActivities = 391,
  msoulscat_Wac_Dictation = 394,
  msoulscat_Wac_OneNoteSync = 395,
  msoulscat_Wac_VisioApp = 700,
  msoulscat_OneNoteOnline_EditableCache = 1601,
  msoulscat_Wac_PptAnimation = 800,
  msoulscat_Wac_PptLive = 833,
  msoulscat_Wac_PptMWeb = 834,
  msoulscat_Wac_PptGc2General = 835,
  msoulscat_Wac_PptGc2GraphicHost = 836,
  msoulscat_Wac_PptGc2Operation = 837,
  msoulscat_Wac_PptGc2EditCanvas = 852,
  msoulscat_Wac_PptDataSync = 844,
  msoulscat_Wac_PptFluidRuntime = 848,
  msoulscat_Wac_PptShape = 815,
  msoulscat_Wac_PptSession = 817,
  msoulscat_Wac_PptSlideshow = 830,
  msoulscat_Wac_PptView = 822,
  msoulscat_Wac_PptVideos = 846,
  msoulscat_Uci_Insights = 1303,
  msoulscat_Wac_VersionHistory = 2300,
  msoulscat_Wac_WordPresence = 302,
  msoulscat_Wac_OAuth = 3000,
  msoulscat_Wac_WordVersionHistory = 3005,
  msoulscat_Wac_LivePersonaCard = 3006,
  msoulscat_Wac_CatchUpFlyout = 3012,
  msoulscat_Wac_WordDesigner = 3016,
  msoulscat_Wac_ModernFontPicker = 3021,
  msoulscat_Wac_UnifiedUiHost = 3027,
  msoulscat_Wac_EquationTools = 3033,
  msoulscat_Osf_Latency = 1401,
  msoulscat_Osf_Notification = 1402,
  msoulscat_Osf_Runtime = 1403,
  msoulscat_Wac_AiMaker = 3041,
  msoulscat_Wac_AiRewrite = 3043,
  msoulscat_Wac_AiInsert = 3044,
  msoulscat_Wac_AiSummarize = 3047,
  msoulscat_Wac_CopilotCompose = 3048,
  msoulscat_Wac_Skittles = 3049,
  msoulscat_Wac_CopilotChat = 3050,
  msoulscat_Wac_Syntex = 3051,
  msoulscat_Wac_WireGraph = 3052,
  msoulscat_Wac_CshCopilot = 3053,
  msoulscat_Wac_CopilotProactiveSummary = 3055,
  msoulscat_Wac_CopilotProactiveShared = 3056,
  msoulscat_Wac_CopilotCursor = 3057,
  msoulscat_Wac_WasmGeneral = 3059,
  msoulscat_Wac_WasmTextLayout = 3060,
  msoulscat_Wac_WasmSmartArt = 3061,
  msoulscat_Wac_WasmClient = 3062,
  msoulscat_Wac_WasmNative = 3063,
  msoulscat_AIHub_CreateModuleTelemetry = 4000,
  // Adding a value to this enum?  You're not done yet!  Please follow instructions from the comment at the top of the file.
}
